import { Accordion, AccordionSummary, Grid, TextField } from "@mui/material";
import { Box, Container, margin } from "@mui/system";
import { CButton } from "../components";
import { ReactComponent as QuranKid } from "../assets/quran-kid.svg";
import { ReactComponent as KolayIcon } from "../assets/kolay.svg";
import { ReactComponent as OzgunIcon } from "../assets/ozgun.svg";
import ContactForm from "../components/ContactForm";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import FindHatm from "../components/FindHatm";
import { useEffect, useState } from "react";
import { useWindowDimensions } from "../components/useWindowDimensions";
import { motion } from "framer-motion";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';



export default function TanitimPage() {

    const { height, width } = useWindowDimensions();

    let kidGrid = 12;
    let textGrid = 12;

    if (width > 900) {
        kidGrid = 5;
        textGrid = 7;
    }

    return <>

        <Container 
            maxWidth="lg" 
        >

            <section style={{ 
                marginBottom: '4rem',
                backgroundSize: '400% 400%',
                animation: 'gradientBG 15s ease infinite',
                borderRadius: '20px',
                padding: width <= 900 ? '2rem 1rem' : '4rem 2rem',
            }}>
                <Grid container
                    component={motion.div}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    spacing={0}
                    sx={{
                        display: 'flex',
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: { xs: 'column-reverse', md: 'row' }
                    }}>

                    <Grid item xs={textGrid}>
                        <motion.div 
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.3, duration: 0.8 }}
                            style={{ 
                                textAlign: width <= 900 ? 'center' : 'left',
                                maxWidth: '600px'
                            }}
                        >
                            <h1 style={{
                                fontSize: width <= 900 ? '1.8rem' : '3rem',
                                marginBottom: '1.5rem',
                                fontWeight: 'bold',
                                lineHeight: 1.2,
                                padding: 0,
                                margin: 0
                            }}>Kuran'ı arkadaşlarınızla tamamlayın</h1>
                            
                            <p style={{
                                fontSize: width <= 900 ? '1rem' : '1.1rem',
                                marginBottom: '2rem',
                                color: '#333',
                                lineHeight: 1.6,
                                opacity: 0.9
                            }}>
                                Hatim organizasyonunu kolaylaştırıyoruz. Birlikte okumanın ve takip etmenin en pratik yolu.
                            </p>

                            <div style={{
                                display: 'flex',
                                gap: '1rem',
                                flexDirection: width <= 900 ? 'column' : 'row',
                                alignItems: width <= 900 ? 'center' : 'flex-start'
                            }}>
                                <CButton 
                                    onClick={() => { window.location = '/giris' }}
                                    endIcon={<ArrowForwardIcon />}
                                    size="large"
                                    variant="contained"
                                    sx={{
                                        padding: '12px 30px',
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        borderRadius: '50px',
                                    
                                        '&:hover': {
                                            backgroundColor: '#0d47a1',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
                                        },
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Hatim Oluştur
                                </CButton>

                                <CButton 
                                    onClick={() => { window.location = '#sss' }}
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        padding: '12px 30px',
                                        fontSize: '1.1rem',
                                        borderRadius: '50px',
                                    
                                        '&:hover': {
                                            borderColor: '#0d47a1',
                                            backgroundColor: 'rgba(26, 35, 126, 0.05)',
                                            transform: 'translateY(-2px)'
                                        },
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Nasıl Çalışır?
                                </CButton>
                            </div>
                        </motion.div>
                    </Grid>

                    <Grid item xs={kidGrid}>
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300 }}
                            style={{
                                maxWidth: width <= 900 ? '80%' : '100%',
                                height: 'auto',
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '0 auto',
                                filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.1))'
                            }}
                        >
                            <QuranKid />
                        </motion.div>
                    </Grid>

                </Grid>

                {/* <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    style={{
                        marginTop: '3rem',
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap'
                    }}
                >
                    {[
                        { number: '1000+', text: 'Tamamlanan Hatim' },
                        { number: '5000+', text: 'Aktif Kullanıcı' },
                        { number: '100%', text: 'Ücretsiz' }
                    ].map((stat, index) => (
                        <div key={index} style={{
                            textAlign: 'center',
                            padding: '1rem',
                            minWidth: '150px'
                        }}>
                            <div style={{
                                fontSize: '1.8rem',
                                fontWeight: 'bold',
                                marginBottom: '0.5rem'
                            }}>{stat.number}</div>
                            <div style={{
                                fontSize: '1rem',
                                color: '#666'
                            }}>{stat.text}</div>
                        </div>
                    ))}
                </motion.div> */}
            </section>

            <section style={{ marginBottom: '4rem' }}>
                <h3 style={{ textAlign: width <= 900 ? 'center' : 'left' }}>Hatmedecem'in Özelliği</h3>
                <div style={{ 
                    display: "flex", 
                    justifyContent: "center",
                    flexDirection: width <= 900 ? 'column' : 'row',
                    gap: "10px",
                    margin: "0 auto",
                    maxWidth: "100%"
                }}>

                    <p>
                    Hatmedecem, kullanıcıların arkadaşlarıyla birlikte Hatim yapmalarına olanak tanır. Kullanıcılar, bitiş tarihini girerek hatim oluşturabilirler. Uygulama, Kuran okuma pratiğini daha özgün hale getirirken, kullanımı kolay bir arayüz sunar.
                </p>

                    <Box sx={{
                        border: "solid 1px #333A3B",
                        borderRadius: '10px',
                        padding: { xs: "12px 12px", sm: "17px 30px", md: "25px 40px" },
                        textAlign: "center",
                        width: width <= 900 ? '100%' : 'auto',
                        boxSizing: 'border-box',
                        '& svg': {
                            maxWidth: '100%',
                            height: 'auto'
                        }
                    }}>
                        <KolayIcon />
                        <h4>Kolay</h4>
                    </Box>

                    <Box sx={{
                        border: "solid 1px #333A3B",
                        borderRadius: '10px',
                        padding: { xs: "12px 12px", sm: "17px 30px", md: "25px 40px" },
                        textAlign: "center",
                        width: width <= 900 ? '100%' : 'auto',
                        boxSizing: 'border-box',
                        '& svg': {
                            maxWidth: '100%',
                            height: 'auto'
                        }
                    }}>
                        <OzgunIcon />
                        <h4>Özgün</h4>
                    </Box>

                </div>

                
            </section>

            <section style={{ marginBottom: '4rem' }} id="sss">
                <h3>Sık Sorulan Sorular</h3>
                <Accordion sx={{ 
                    border: "solid 1px #333A3B", 
                    borderRadius: "10px", 
                    boxShadow: "none", 
                    marginBottom: "10px",
                    '& .MuiAccordionSummary-content': {
                        margin: { xs: '10px 0', sm: '12px 0' }
                    }
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Nasıl Hatim Oluşturulur?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <ul style={{ paddingLeft: "15px", margin: "0" }}>
                                <li>Hatim oluşturma sayfasına girin.</li>
                                <li>Hatim başlığı ve bitiş tarihini girin.</li>
                                <li>İşlemi tamamlama butonuna basın.</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion sx={{ 
                    border: "solid 1px #333A3B", 
                    borderRadius: "10px", 
                    boxShadow: "none", 
                    marginBottom: "10px",
                    '& .MuiAccordionSummary-content': {
                        margin: { xs: '10px 0', sm: '12px 0' }
                    }
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Nasıl Hatim Paylaşılır?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <ul style={{ paddingLeft: "15px", margin: "0" }}>
                                <li>Hatim sayfasına girin.</li>
                                <li>Hatmi paylaş bölümünde istediğiniz yöntemi seçin.</li>
                                <li>Direkt istediğiniz platform üzerinden ya da linki kopyalayarak arkadaşlarınıza atın.</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion sx={{ 
                    border: "solid 1px #333A3B", 
                    borderRadius: "10px", 
                    boxShadow: "none", 
                    marginBottom: "10px",
                    '& .MuiAccordionSummary-content': {
                        margin: { xs: '10px 0', sm: '12px 0' }
                    }
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Hatime Nasıl Katılınır?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <ul style={{ paddingLeft: "15px", margin: "0" }}>
                                <li>Arkadaşınızın hatim sayfası linkine girin.</li>
                                <li>Okuyacağınız cüzleri seçin.</li>
                                <li>İsminizi yazın.</li>
                                <li>İşlemi tamamlama butonuna basın.</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>

            </section>

            <section style={{ marginBottom: '4rem' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    margin: '20px 0'
                }}>
                    <div style={{
                        fontSize: width <= 900 ? '24px' : '32px',
                        fontFamily: 'Amiri, serif',
                        direction: 'rtl',
                        textAlign: 'center'
                    }}>
                        ٱقْرَأْ بِٱسْمِ رَبِّكَ ٱلَّذِى خَلَقَ
                    </div>
                    <div style={{
                        fontSize: width <= 900 ? '16px' : '20px',
                        color: '#666',
                        textAlign: 'center'
                    }}>
                        Yaratan Rabbinin adıyla oku!
                    </div>
                </div>
            </section>

            <section style={{ marginBottom: '4rem' }}>
                <FindHatm />
            </section>


            <section>
                <ContactForm />
            </section>

            <br />

        </Container>

    </>
}